const state = {
  roles: [],
  permissions:[],
  rolePermissions:[],
  trashedRoles:[],
  models:[]
}
export default state
